import React, { useState, useEffect } from "react";
import { TabContent, TabPane, Nav, NavItem } from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";
import { history } from "../../../../history";
import { IoIosArrowDown } from "react-icons/io";

const Menu = ({ UI }) => {
    const [menu, setMenu] = useState(JSON.parse(localStorage.getItem('menu')) || []);
    const [activeOut, setActiveOut] = useState(null);
    const [activeIn, setActiveIn] = useState(null);
    const [activeTab, setActiveTab] = useState("1");
    const [active, setActive] = useState("");
    const [grandChild, setGrandChild] = useState([]);
    const MenuType = {
        Category: 0,
        Link: 1
    }
    const MenuOpen = {
        InTab: 0,
        NewTab: 1
    }

    useEffect(() => {
        if (UI.menu) {
            setMenu(UI.menu);
        }
    }, [UI.menu]);
    useEffect(()=>{
        setActive(window.location.pathname)
    }, [window.location.pathname])

    const toggleOut = (tabId) => {
        setActiveOut(prevActiveOut => {
            const newActiveOut = prevActiveOut !== tabId ? tabId : null;
            if (newActiveOut === null) {
                setActiveTab("1");
                setGrandChild([]);
            } else {
                const newChildData = menu.filter(p => p.parentId === newActiveOut);
                if (newChildData.length > 0) {
                    tabToggle(0, newChildData[0]);
                } else {
                    setGrandChild([]);
                }
            }
            return newActiveOut;
        });
        setActiveIn(null);
    };


    const toggleIn = (tabId) => {
        setActiveIn(prevActiveIn => prevActiveIn !== tabId ? tabId : null);
    };

    const closeMenu = () => {
        setActiveOut(null);
        setActiveIn(null);
        setActiveTab("1");
        setGrandChild([]); // Clear grandchild data when menu is closed
    };

    const tabToggle = (tab, data) => {
            const filterData = menu.filter(p => p.parentId === data.id);
            setActiveTab((tab + 1).toString());
            setGrandChild(filterData);
            setActiveIn(null);
    };

    const handleUrl = (item) => {
        switch (parseInt(item.type)) {
            case MenuType.Category:
                history.push(`/courses/${item.category.value}`);
                break;
            case MenuType.Link:
                if (isValidUrl(item.url)) {
                    switch (parseInt(item.openIn)) {
                        case MenuOpen.InTab:
                            window.location = item.url;
                            break;
                        case MenuOpen.NewTab:
                            window.open(item.url, "_blank");
                            break;
                    }
                } else {
                    history.push(item.url);
                }
                break;
        }
        setActive(item.id)
    }

    const isValidUrl = urlString => {
        let url;
        try {
            url = new URL(urlString);
        } catch (e) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    }

    const renderMenu = menu.filter(item => item.parentId === "main").map((parent, index) => (
        <>
            {
                parent.canHaveChild ?
                    <NavItem key={index} className="product-btn cursor-pointer" onMouseEnter={() => toggleOut(parent.id)}>
                        <div
                            onClick={() => handleUrl(parent)}
                            className={parseInt(active) === parseInt(parent.id) || active === parent.url ? "product-btn-item-active" : "product-btn-item"}
                        >
                            {parent.title}
                            <IoIosArrowDown size={16} className="" />
                        </div>
                    </NavItem> :
                    <NavItem key={index} className="product-btn cursor-pointer">
                        <NavLink to={parent.url}
                                 onClick={() => handleUrl(parent)}
                                 className={parseInt(active) === parseInt(parent.id) || active === parent.url ? "product-btn-item-active" : "product-btn-item"}
                        >
                            {parent.title}
                        </NavLink>
                    </NavItem>
            }
        </>
    ));

    const renderChildren = (
        <Nav tabs className="mb-0 justify-content-around">
            {menu.filter(item => item.parentId === activeOut).map((child, index) => (
                <NavItem key={index} className="cursor-pointer">
                    <div
                        onClick={() => tabToggle(index, child)}
                        className={classnames({
                            "menu-tab-active": activeTab === (index + 1).toString(),
                            "menu-tab-disabled": activeTab !== (index + 1).toString(),
                        })}
                    >
                        <span>{child.title}</span>
                    </div>
                </NavItem>
            ))}
        </Nav>
    );

    const renderGrandChildren = grandChild.map((grandChildItem, index) => (
        <div
            key={index}
            onClick={() => handleUrl(grandChildItem)}
            className="grandChild cursor-pointer"
            onMouseEnter={() => setActiveIn(grandChildItem.id)}
        >
            {grandChildItem.title}
        </div>
    ));

    const renderGrandGrandChildren = menu.filter(p => p.parentId === activeIn).map((grandChildItem, index) => (
        <div key={index} className="menu-level-four">
            <div
                onClick={() => handleUrl(grandChildItem)}
                className="grandGrandChild cursor-pointer"
            >
                {grandChildItem.title}
            </div>
            <ul>
                {menu.filter(p => p.parentId === grandChildItem.id).map((grandGrandChild, index) => (
                    <li key={index} className="mx-1" onClick={() => handleUrl(grandGrandChild)}>
                        <a href={grandGrandChild.link} className="grandchildren">
                            {grandGrandChild.title}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    ));

    return (
        <div className="header-main d-flex justify-content-between">
            <div className="mega-menu">
                <Nav pills className="justify-content-center align-items-center mb-0">
                    {renderMenu}
                </Nav>
                {activeOut && (
                    <>
                        <div className="mega-menu-shadow"></div>
                        <div className="wrapper rounded" onMouseLeave={closeMenu}>
                            <div className="child-1">{renderChildren}</div>
                            <div className="d-flex">
                                <TabContent className="menu-content In" activeTab={activeTab}>
                                    <TabPane tabId={activeTab}>
                                        {renderGrandChildren}
                                    </TabPane>
                                </TabContent>
                                <div className="p-1">
                                    {renderGrandGrandChildren}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    UI: state.UI,
});

export default connect(mapStateToProps)(Menu);
